<template>
  <div class="container">
    <div class="result">
      <div class="card">
        <div class="card-title">
          <div class="left">
            <img src="@/assets/images/icon1.svg">
            <span>立项用地规划许可</span>
          </div>
        </div>
        <van-checkbox-group v-model="siteResult">
          <van-cell-group>
            <van-cell :title="`${index + 1}、${item}`" v-for="(item, index) in siteList" :key="'site'+index" :border="false">
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div class="card">
        <div class="card-title">
          <div class="left">
            <img src="@/assets/images/icon2.svg">
            <span>工程建设许可</span>
          </div>
        </div>
        <van-checkbox-group v-model="buildResult">
          <van-cell-group>
            <van-cell :title="`${index + 1}、${item}`" v-for="(item, index) in buildList" :key="'build'+index" :border="false">
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div class="card">
        <div class="card-title">
          <div class="left">
            <img src="@/assets/images/icon3.svg">
            <span>施工许可</span>
          </div>
        </div>
        <van-checkbox-group v-model="construteResult">
          <van-cell-group>
            <van-cell :title="`${index + 1}、${item}`" v-for="(item, index) in construteList" :key="'construte'+index" :border="false">
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

      </div>
      <div class="card">
        <div class="card-title">
          <div class="left">
            <img src="@/assets/images/icon4.svg">
            <span>竣工验收</span>
          </div>
        </div>
        <van-checkbox-group v-model="doneResult">
          <van-cell-group>
            <van-cell :title="`${index + 1}、${item}`" v-for="(item, index) in doneList" :key="'done'+index" :border="false">
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
      <div class="card">
        <div class="card-title">
          <div class="left">
            <img src="@/assets/images/icon1.svg">
            <span>并行推进</span> 
          </div>
        </div>
        <van-checkbox-group v-model="parallelAdvancementResult">
          <van-cell-group>
            <van-cell :title="`${index + 1}、${item}`" v-for="(item, index) in parallelAdvancementList" :key="'parallelAdvancement'+index" :border="false">
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
  </div>
</template>
<script>
import { getItemCustom } from '@/api/interface/project.js'
export default {
  name: 'matter',
  data() {
    return {
      siteList: [],
      buildList: [],
      construteList: [],
      doneList: [],
      parallelAdvancementList:[],
      active: 0,
      siteResult: [],
      siteVisible: false,
      buildResult: [],
      buildVisible: false,
      construteResult: [],
      construteVisible: false,
      doneResult: [],
      doneVisible: false,
      parallelAdvancementResult: [],
      parallelAdvancementVisible: false,
      code:null
    }
  },
  methods:{
    getDataList() {
      const dataInstance = getItemCustom({
      seqId: this.code.get('seqId'),
    })
    dataInstance
      .then((result) => {
        this.listData = result.data
        this.siteList=result['1']
        this.buildList=result['2']
        this.construteList=result['3']
        this.doneList=result['4']
        this.parallelAdvancementList=result['5']
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  created() {  
    try {
      const href = location.href
      this.code = new Map()
      if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
        const temp = item.split('=')
        this.code.set(temp[0], temp[1].split('#')[0])
      });
    } catch (err) {
      console.log(err);
    }
  },
  mounted(){
    this.getDataList()
  }
}
</script>
<style lang="less" scoped>
.container {
  padding: 0px 8px;
  height: 100%;
}

.sub-head {
  font-size: 16px;
  font-weight: 600;
}

.step-list {
  margin-top: 20px;

  >li {
    padding-bottom: 20px;
    padding-left: 20px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      width: 1px;
      background: #eaebee;
      top: 0;
      bottom: 0;
      left: 0;
    }

    &:first-child {
      &:before {
        top: 10px;
      }
    }

    &:last-child {
      &:before {
        bottom: 35px;
        // display: none;
      }
    }
  }

  .step-item {
    position: relative;

    .circle {
      height: 9px;
      width: 9px;
      border: 1px solid #fff;
      background: #eaebee;
      position: absolute;
      top: 10px;
      left: -24px;
      border-radius: 50%;
    }

    .step-item-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 12px;
      background: linear-gradient(90deg,
          rgba(219, 219, 219, 0.3) 0%,
          rgba(242, 242, 242, 0.3) 100%);

      span {
        display: flex;
        align-items: center;

        svg {
          margin-right: 5px;
        }
      }
    }

    .step-item-body {
      .van-cell {
        background: transparent;
        padding-top: 0 !important;
        padding-bottom: 0px !important;
        font-weight: normal;
        margin-top: 14px;
      }

      .bg-success {
        background: linear-gradient(90deg,
            rgba(44, 174, 97, 0.3) 0%,
            rgba(237, 248, 241, 0.3) 100%);
      }

      .bg-primary {
        background: linear-gradient(90deg,
            rgba(66, 122, 244, 0.3) 0%,
            rgba(237, 242, 248, 0.3) 100%);
      }
    }

    &.step-success {
      background: linear-gradient(180deg,
          rgba(44, 174, 97, 0.05) 13.97%,
          rgba(255, 255, 255, 0.05) 100%);

      // rgba(44, 174, 97, 1), rgba(255, 255, 255, 1)
      .step-item-head {
        background: linear-gradient(90deg,
            rgba(44, 174, 97, 0.3) 0%,
            rgba(237, 248, 241, 0.3) 100%);
      }
    }

    &.step-primary {
      .step-item-head {
        background: linear-gradient(90deg,
            rgba(66, 122, 244, 0.3) 0%,
            rgba(237, 242, 248, 0.3) 100%);
      }
    }
  }
}
</style>
<style lang="less" scoped>
.result::-webkit-scrollbar{
  display: none;
}
.result {
  padding: 12px 16px;
  height: calc(100vh - 64px - 46px);
  overflow: scroll;
  background-color: rgb(245,246,247);
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #000;
    margin-bottom: 16px;
  }

  .card {
    padding: 8px 0;
    border-radius: 6px;
    background: #FFF;

    .card-title {
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #0273C7;
      font-weight: 600;
      margin-bottom: 12px;

      img {
        width: 16px;
        height: 16px;
      }

      .left {
        display: flex;
        align-items: center;
        column-gap: 8px;
        span{
          color: #000;
        }
      }

      .edit {
        display: flex;
        align-items: center;
        column-gap: 4px;
        color: #0273C7;
        font-size: 14px;
        font-weight: 400;
      }
    }

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  ::v-deep {
    .van-hairline--top-bottom::after {
      border-width: 0;
    }

    .van-cell {
      align-items: center;
      column-gap: 10px;

      .van-cell__title {
        order: 1;
        font-size: 15px;
        font-weight: 400;
        color: #000;
      }

      .van-cell__value {
        order: 0;
        flex: 0 1 auto;
      }

    }

    .van-checkbox__icon {
      height: 16px;
      height: 16px;

      .van-icon {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
      }
    }

    .van-checkbox__icon--checked {
      .van-icon-success {
        background: #0273C7;
        color: #fff;
      }
    }

    .van-checkbox-group {
      .van-cell {
        padding: 16px;

        &::after {
          border-bottom: 1px solid #eee;
          left: 0;
          right: 0;
        }
      }
    }
  }
}

.bot-btns {
  background: #FFF;
  height: 64px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .van-button {
    width: 100%;
    border-radius: 6px;
    background: #0273C7;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
}</style>